import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

interface MappingFeatureUnavailableProps {
  heading?: string;
  intro?: string;
  title?: string;
  description?: string;
}

export function MappingFeatureUnavailable({
  heading = 'Maps',
  intro = 'Mapping is currently disabled for this tenant.',
  title = 'Mapping feature unavailable',
  description = 'Mapping features are disabled for your current tenant. Contact your administrator if you believe this is an error.'
}: MappingFeatureUnavailableProps) {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-semibold text-foreground">{heading}</h1>
        <p className="text-sm text-muted-foreground">{intro}</p>
      </div>
      <Card>
        <CardHeader>
          <CardTitle>{title}</CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-sm text-muted-foreground">{description}</p>
        </CardContent>
      </Card>
    </div>
  );
}

export function MappingPermissionDenied() {
  return (
    <MappingFeatureUnavailable
      intro="This tenant has mapping enabled, but your account does not have permission to use these tools."
      title="You do not have permissions"
      description="Ask a tenant administrator to grant your account the required mapping permissions in svc-tenant if you need access."
    />
  );
}
